import React, { useContext } from 'react'
import { createSearchParams, useNavigate, useSearchParams } from 'react-router-dom';
import { GVarState } from '../StoreState/Gstate';

function DisplaySearchItem() {
    let g = useContext(GVarState);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate()
    return (
        <>
            {g.DisplayEndPointResult && <div className='displayStart'>
                {g.DisplayEndPointResult.map((d, i) => {
                    return <p key={i} onClick={() => {
                        g.setEndSearchInput({ name: d.LocationName.text, point: d })
                        g.setDisplayEndPointResult(null)
                        let params = {};
                        searchParams.forEach((d, i) => {
                            if (i == "v" || i == "m") params[i] = d;
                        });
                        let selectData = btoa(`${d.x},${d.y},${d.z} `);
                        params.selectData = selectData;
                        navigate({
                            pathname: "/",
                            search: `?${createSearchParams(params)}`,
                        })
                    }}> {d.LocationName.text} </p>

                })}
            </div>
            }
        </>
    )
}

export default DisplaySearchItem